/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Type/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Type({
  children,
  viewPath = "/App/Account/Chairs/Content/Appointments/Content/Appointment/Type"
  
}) {
let appointmentBookingAppointmentTypeFullNameValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'appointment_type.full_name',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="regular"
 size="small"
 color={dtColorsNeutral600}
 textOverflow="ellipsis"
 overflowX="hidden"
 overflowY="hidden"
 whiteSpace="nowrap"
 data="appointment_booking.appointment_type.full_name"
 text={appointmentBookingAppointmentTypeFullNameValueData}
/>
{children}
</React.Fragment>)
}